import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCbG72Mhb37f78bBvj16sINPIYBhht8Abk",
  authDomain: "fdevllc.firebaseapp.com",
  databaseURL: "https://fdevllc-default-rtdb.europe-west1.firebasedatabase.app/",
  projectId: "fdevllc",
  storageBucket: "fdevllc.firebasestorage.app",
  messagingSenderId: "561630331860",
  appId: "1:561630331860:web:588b6beffa12ba98094c41",
  measurementId: "G-V2CJZVM7PR"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const functions = getFunctions(app, 'europe-west1');

// Initialize analytics with proper error handling
let analytics = null;
try {
  // Check if analytics is supported and initialize only if it is
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  }).catch((error) => {
    console.warn('Firebase Analytics not available:', error.message);
  });
} catch (error) {
  console.warn('Firebase Analytics initialization failed:', error.message);
}

export { analytics };

export const database = getDatabase(app);

export default app;